(function () {
  function initHoverZoom() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var tpl = (main.dataset.template || '').split('.')[0];
    if (tpl !== 'product') return;

    main.querySelectorAll('.product-media').forEach(function (container) {
      if (container._hoverZoomInit) return;
      container._hoverZoomInit = true;

      var img = container.querySelector('img');
      if (!img) return;

      container.addEventListener('mousemove', function (e) {
        var r = container.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      container.addEventListener('mouseleave', function () {
        img.style.transformOrigin = '50% 50%';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverZoom);
  } else {
    initHoverZoom();
  }

  document.addEventListener('shopify:section:load', initHoverZoom);
})();
